export const LOGIN_USER = "LOGIN_USER";
export const LOG_OUT = "LOG_OUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const EDIT_USER = "EDIT_USER"; 